module.exports = __webpack_public_path__ + "static/img/zhibaozhan.b941e6c5.png";